import { DateFactory } from 'rhg-vue-common'

export default class Corporate {
  static fromJSON({ ...rest }) {
    return new Corporate({
      ...rest
    })
  }

  constructor({ id, name, points, firstPointsExpiration }) {
    this.id = id
    this.name = name
    this.points = points
    this.firstPointsExpiration = firstPointsExpiration
  }

  pointsExpirationNumber() {
    return this.firstPointsExpiration?.points
  }

  pointsExpirationDate(date, format = 'DD/MM/YYYY') {
    return DateFactory.formatDate(date, format)
  }

  pointsExpirationDays() {
    return this.firstPointsExpiration?.days
  }
}
